import { PeopleSelectionDropdown } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitLogotipos/components/broadcastComponents/PeopleSelectionDropdown';
import { buildNewPeopleDataToSave } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitLogotipos/helpers/batchSelectionHelpers';
import {
  FrameActionType,
  PostLogoFor,
  PostPresenceFor,
  TBroadcastScheduleOnUpdateInline,
} from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitLogotipos/types';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { TClipPeople } from '@/features/clips/types';
import { TFeaturedPeopleType } from '@/features/featured-people/types';
import { TSegmentPeople } from '@/features/segments/types';

import { PresenceInlineDropdown } from './PresenceInlineDropdown';

type PeoplePresenceDropdownProps<T extends TSegmentPeople | TClipPeople> = {
  item: T;
  /** The people the table has resolved for its rows; a row never asks for its own. */
  peopleById: ReadonlyMap<string, TFeaturedPeopleType>;
  onUpdateInline?: TBroadcastScheduleOnUpdateInline<PostLogoFor<T>>;
  onPreview?: (item: T, frame?: FrameActionType) => void;
  hasParent?: boolean;
  parentCallback?: () => void;
  buildDataToSave?: (item: T) => PostPresenceFor<T>;
};

export function PeoplePresenceDropdown<T extends TSegmentPeople | TClipPeople>({
  item,
  peopleById,
  buildDataToSave = buildNewPeopleDataToSave as (item: T) => PostPresenceFor<T>,
  ...rest
}: PeoplePresenceDropdownProps<T>) {
  const { personaData, personaClipData } = useBroadcastScheduleProgram();

  const peopleId = 'people_id' in item ? item.people_id : (item as { id: string }).id;
  const person = peopleId ? peopleById.get(peopleId) : undefined;

  const presenceData =
    'clip_id' in item ? (personaClipData ?? undefined) : (personaData ?? undefined);

  const imageConfig = {
    url: person?.parameters?.main_logo_presigned_url || '/default-logo.svg',
    alt: person?.name || item.entity_label || '',
    name: person?.name || item.entity_label || '',
    contentClassName: 'justify-start w-full',
  };

  return (
    <PresenceInlineDropdown
      item={item}
      imageConfig={imageConfig}
      renderDropdown={onChange => <PeopleSelectionDropdown onChange={onChange} />}
      presenceData={presenceData}
      buildDataToSave={buildDataToSave}
      {...rest}
    />
  );
}
